import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { OrgBuilderFacade } from '@app/org-builder/state/org-builder.facade';
import { TableService } from '@app/shared/services/table.service';
import { Observable, combineLatest, startWith, map, Subject, BehaviorSubject } from 'rxjs';
import { Task } from '@entities/task';

@Component({
   selector: 'app-task-multiselect',
   templateUrl: './task-multiselect.component.html',
   styleUrls: ['./task-multiselect.component.scss'],
})
export class TaskMultiselectComponent {
   @Input() label = 'Tasks';
   @Input() canEdit = true;
   @Input() selected: Task[] = [];
   @Input() priorityTasks$: Observable<string[]> = new BehaviorSubject<string[]>([]);
   @Input() priorityTasksLabel = 'Priority Tasks';
   @Output() selectionChange = new EventEmitter<Task[]>();

   tasks$: Observable<Task[]>;
   filteredTasks$: Observable<Task[]>;
   filteredPriorityTasks$: Observable<Task[]>;

   form: UntypedFormGroup;

   constructor(private orgBuilderFacade: OrgBuilderFacade, private tableService: TableService) {}

   ngOnInit(): void {
      this.form = new UntypedFormGroup({
         filter: new UntypedFormControl(),
         tasks: new UntypedFormControl(this.selected),
      });
      this.tasks$ = this.orgBuilderFacade.tasks$;
      this.filteredTasks$ = combineLatest([
         this.tasks$,
         this.form.get('filter').valueChanges.pipe(startWith('')),
      ]).pipe(
         map(([tasks, filter]) => {
            return this.tableService.filterAndSort(tasks, filter, ['name'], {
               active: 'name',
               direction: 'asc',
            });
         })
      );
      this.filteredPriorityTasks$ = combineLatest([
         this.filteredTasks$,
         this.priorityTasks$.pipe(startWith([])),
      ]).pipe(
         map(([filtered, priority]) => {
            return filtered.filter((task) => priority.includes(task.id));
         })
      );
   }

   ngOnChanges(changes: SimpleChanges) {
      if (changes['canEdit']) {
         if (this.form) {
            if (this.canEdit) {
               this.form.enable();
            } else {
               this.form.disable();
            }
         }
      }
      if (changes['selected']) {
         if (this.form && this.selected) {
            this.form.patchValue({
               tasks: this.selected,
            });
         }
      }
   }

   tasksUpdated(event: MatSelectChange) {
      this.selectionChange.emit(event.value);
   }

   getControl(name: string): UntypedFormControl {
      return this.form.get(name) as UntypedFormControl;
   }

   compareById = (a, b) => a?.id === b?.id;
}

